import Hls from 'hls.js';
import { HLS_SUPPORT } from '@videotools/js/components/player/enums';

const getHlsSupport = () => {
	const hlsSupport = Hls.isSupported();
	const testVideoElement = document.createElement('video');
	const hasNativeHLSSupport = testVideoElement.canPlayType('application/vnd.apple.mpegurl');
	if (hlsSupport && hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE_AND_MSE;
	}
	if (hlsSupport) {
		return HLS_SUPPORT.SUPPORTED_MSE;
	}
	if (hasNativeHLSSupport) {
		return HLS_SUPPORT.SUPPORTED_NATIVE;
	}
	return HLS_SUPPORT.UNSUPPORTED;
};

const getAudioTrackListSupport = () => {
	const testVideoElement = document.createElement('video');
	return testVideoElement.audioTracks !== undefined;
};

export default {
	getHlsSupport,
	getAudioTrackListSupport,
};
